import * as yup from 'yup';

export const validationSchema = yup.object({
  companyType: yup.string().required('Please choose company type'),
  contactName: yup.string().min(2, 'Must be 2 characters or more').required('Please enter contact name'),
  contactEmail: yup.string().email('Provided email is in invalid format').required('Please enter email'),
  bccEmail: yup.string().email('Provided email is in invalid format').nullable(),
  companyName: yup.string().min(2, 'Must be 2 characters or more').required('Please enter company name'),
});
